import { STORAGE_KEYS } from '@/constants/storage'
import localStorage from '@/utils/localStorage'
import safeJSONParse from '@/utils/safeJSONParse'

/**
 * This returns the list of names of visited Tours (Handholding)
 * @returns {Object|*[]}
 */
export default () => {
  const visitedTours = localStorage.getItem(STORAGE_KEYS.visitedTours)
  return safeJSONParse(visitedTours) || []
}
